import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import About from "./About";
import VisionMission from "./VisionMission";
import WhyDoubleTap from "./WhyDoubleTap";
import LaunchingSoon from "./LaunchingSoon";
import Contact from "./Contact";
import Footer from "./Footer";

const Home = () => {
  return (
    <div className="home">
      <Header />
      <Hero />
      <About />
      <VisionMission />
      <WhyDoubleTap />
      <LaunchingSoon />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;